import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})

export class ModalService {

    private tipo = new BehaviorSubject<string[]>([]);
    private titulo = new BehaviorSubject<string>("");
    private mensaje = new BehaviorSubject<string>("");
    private abrirModal = new BehaviorSubject<boolean>(false);
    private icono = new BehaviorSubject<string>("");
    
    public readonly tipo$ = this.tipo.asObservable();
    public readonly titulo$ = this.titulo.asObservable();
    public readonly mensaje$ = this.mensaje.asObservable();
    public readonly abrirModal$ = this.abrirModal.asObservable();
    public readonly icono$ = this.icono.asObservable();

    public readonly TIPO_MODAL = {
        SUCCESS: "success",
        ERROR: "error",
        WARING: "waring"
    }  
    mostrarMensaje(tipo: string, titulo: string, mensaje: string) {
        this.titulo.next(titulo);
        this.mensaje.next(mensaje);
        if(tipo == "success"){
            this.tipo.next(['alert-success'])
            this.icono.next("check_circle")
        }else if(tipo == "error"){
            this.tipo.next(['alert-error'])
            this.icono.next("cancel")
        }else if(tipo == "waring"){
            this.tipo.next(['alert-waring'])
            this.icono.next('error');
        }
        this.abrirModal.next(true);
    }

    cerrarModal() {
        this.abrirModal.next(false);
    }
}